import { EBuildersInfoActionTypes } from '../../actions/buildersInfo';
import { EPaginationActionTypes } from '../../actions/pagination';
import { TPagination } from '../../types/redux/state';
import { TReduxActions } from '../../types/redux';

const DEFAULT_STATE: TPagination = {
  pageCount: 1,
  pageOptions: [],
};

export const paginationReducer = (state: TPagination = DEFAULT_STATE, action: TReduxActions) => {
  switch (action.type) {
    case EBuildersInfoActionTypes.Success:
      return {
        ...state,
        pageCount: action.payload.pageCount,
      };
    case EPaginationActionTypes.SetPageOptions:
      return {
        ...state,
        pageOptions: action.payload,
      };

    default:
      return state;
  }
};
